import { configureStore, } from '@reduxjs/toolkit'
import currentUser from '../reducers/currentUser'
import usersList from '../reducers/usersList'
import accountsList from '../reducers/accountsList'
import editingUser from '../reducers/editingUser'
import editingAccount from '../reducers/editingAccount'
import deleteUser from '../reducers/deleteUser'
import deleteAccount from '../reducers/deleteAccount'
import siteNoti from '../reducers/siteNoti'
import filterUser from '../reducers/filterUser'
import filterAccount from '../reducers/filterAccount'
import roomDesign from '../reducers/roomDesign'
import itemRemoval from '../reducers/itemRemoval'
import imageEditing from '../reducers/imageEditing'
import editPhoto from '../reducers/editPhoto'
import toast from '../reducers/toast'
import serviceSettings from '../reducers/serviceSettings'
import accountUsers from '../reducers/accountUsers'
import floorPlanExtraction from '../reducers/floorPlanExtraction'
import panorama from '../reducers/panorama'

const store = configureStore({
    reducer: {
        currentUser,
        usersList,
        accountsList,
        editingUser,
        editingAccount,
        deleteUser,
        deleteAccount,
        siteNoti,
        filterUser,
        filterAccount,
        roomDesign,
        itemRemoval,
        imageEditing,
        editPhoto,
        toast,
        serviceSettings,
        accountUsers,
        floorPlanExtraction,
        panorama,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
          serializableCheck: false,
        }),
})

export default store
